
import { defineComponent, inject, ref, computed, nextTick, provide } from 'vue'

//services
import PayrollService from "@/core/services/PayrollService"
import { errManager } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";
//icons
import { Search } from '@element-plus/icons-vue'
import ModalSearch from '@/views/planilla/modals/ModalSearch.vue';
import ModalPerfil from '@/views/planilla/modals/ModalPerfil.vue';

export default defineComponent({
    components: { ModalSearch, ModalPerfil },
    props: {
        typeRegister: {
            type: String,
            required: true,
            default: ''
        },
        sport: {
            type: null,
            required: false,
            default: {}
        },
        event: {
            type: null,
            required: false,
            default: {}
        },
        rowClub: {
            type: Object,
            required: false,
            default: {}
        }
    },
    emits: ["getSelectRow"],
    setup(props, { emit }) {
        const { t } = useI18n();
        const altura = screen.height - 350;
        const REPO = ref(process.env.VUE_APP_REPO)
        const loaderTable = ref(false);
        const listRows = ref<any>([]);
        const searchText = ref<any>("");
        const ModalSearchRef = ref<any>(null);
        const dialogProfile = ref(false);
        const dataProfile = ref(<any>{});
        const action = ref<Number>(0)
        //get sharing data
        const gblDialog = inject<any>('gblDialog');
        provide("dialogProfile", dialogProfile);
        provide("dataProfile", dataProfile);

        const normalize = (s: string) =>
        (s ?? '')
            .toString()
            .normalize?.('NFD')                     // separa diacríticos (si el navegador lo soporta)
            .replace(/[\u0300-\u036f]/g, '')        // elimina acentos
            .toLowerCase()
            .trim();

        const geDataPayroll = async () => {
            loaderTable.value = true
            await PayrollService.getData({ textSearch: '', 
                status: [1], 
                origin: 'select', 
                gender: props.sport?.gender, 
                typeRegister: props.typeRegister, 
                idevent:props.event?.idevent,
                idinstitution: props.rowClub?.idinstitution
            })
                .then((res) => {
                    loaderTable.value = false
                    //listRows.value = res.data.list;
                    if(res.data.list){
                        listRows.value = res.data.list.map(r=>({
                            ...r,
                            _fullNameNorm: normalize(`${r.firstname ?? ''} ${r.lastname ?? ''} ${r.surname ?? ''}`),
                            _docNorm: normalize(String(r.docnumber ?? ''))
                        }));
                    }
                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })
        }

        
        const filteredList = computed(() => {
            const search = normalize(searchText.value);

            // vacío -> devolver todo
            if (!search) return listRows.value;

            const tokens = searchText.value.split(/\s+/).filter(Boolean);

            return listRows.value.filter((item) =>
                //const fullName = normalize(`${item.firstname ?? ''} ${item.lastname ?? ''} ${item.surname ?? ''}`);
                //const doc = normalize(String(item.docnumber ?? ''));

                tokens.every(
                    (token) => item._fullNameNorm.includes(token) || item._docNorm.includes(token)
                )
            );
        });

        /**
         * (item) =>
                    item.firstname.toLowerCase().includes(searchText.value.toLowerCase()) ||
                    item.lastname.toLowerCase().includes(searchText.value.toLowerCase()) ||
                    item.docnumber.includes(searchText.value.toLowerCase())
            );
         */

        const onOpened = () => {
            geDataPayroll()
        }

        const onClosed = () => {
            searchText.value = ""
            listRows.value = []
        }

        const setSelectRow = (row) => {
            emit("getSelectRow", row)
            gblDialog.value = false
            //validar si cumple los requisitos antes de pasar al otro modal de registro
            /*if (props.typeRegister == 'D' && row.edad > 28) {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    html: "El participante no cumple con la edad requerida para participar como <b>Deportista</b>",
                });
            } else {
                emit("getSelectRow", row)
                gblDialog.value = false
            }
            */
        };

        const openModalSearch = () => {
            if (ModalSearchRef.value) {
                ModalSearchRef.value.openModal();
            }
        };

        //metodo de respuesta del ModalSearch
        const onResponse = (data) => {
            nextTick(() => {
                if (!data.status) {
                    action.value = data.action
                    dataProfile.value = data
                    dialogProfile.value = true
                }
            })
        }

        return {
            t,
            REPO,
            altura,
            gblDialog,
            loaderTable,
            listRows,
            searchText,
            ModalSearchRef,
            action,
            //icons
            Search,
            //events
            onOpened,
            onClosed,
            setSelectRow,
            filteredList,
            openModalSearch,
            onResponse,
            geDataPayroll
        }

    },
})
